import { useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { BsInfoCircle } from 'react-icons/bs';
import ReactTooltip from 'react-tooltip';
import CheckListOptionsCatalogState from './CheckListOptionsCatalogState';
import CheckListOptionsCatalogStateLocat from './CheckListOptionsCatalogStateLocat';
import CheckListOptionsCatalogStateMulti from './CheckListOptionsCatalogStateMulti';
import EndUserRemoveFilterOptionsL3 from './EndUserRemoveFilterOptionsL3';
import PercentajeReactInputRange from './PercentajeReactInputRange';
import { startPanelFilterSchema } from '../../app/actions/semanticIntegrationActions';
import {
  getPanelComboDataList,
  moduleHasIndicators,
  panelComboWidgetKind,
  PANEL_INDICATORS,
} from './panelL3ComboRegistry';

const INDICATORS_TITLE = 'indicators_title';
const INDICATORS_TITLE_INFO = 'indicators_title_info';

const L3FilterDynamic = (props) => {
  const {
    searchTextState,
    catalogsToFilter,
    setCatalogsToFilter,
    itemsPerPage,
    setItemsPerPage,
    moduleSelected,
    setModuleSelected,
    catalogCiiuLevel1Selected,
    setCatalogCiiuLevel1Selected,
    indicatorsToFilter,
    setIndicatorsToFilter,
    groupVisionSelected,
    setGroupVisionSelected,
    concernSelected,
    setConcernSelected,
  } = props;

  const { t } = useTranslation();
  const reduxState = useSelector((state) => state);
  const catalog = reduxState.catalog || {};
  const moduleKey = moduleSelected?.key;
  const [schema, setSchema] = useState({ enabled: false, combos: [] });

  useEffect(() => {
    let cancelled = false;
    if (!moduleKey) return undefined;
    const load = async () => {
      const resp = await startPanelFilterSchema(moduleKey)();
      if (!cancelled && resp?.ok) setSchema(resp.schema || { enabled: false, combos: [] });
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [moduleKey]);

  const shared = {
    searchTextState,
    catalogsToFilter,
    setCatalogsToFilter,
    itemsPerPage,
    setItemsPerPage,
    moduleSelected,
    catalogCiiuLevel1Selected,
    indicatorsToFilter,
    setIndicatorsToFilter,
    groupVisionSelected,
    setGroupVisionSelected,
    concernSelected,
    setConcernSelected,
  };

  const combos = schema.combos || [];
  const mk = moduleKey || '';

  const renderCombo = (combo, index) => {
    const field = combo.field_name;
    const kind = panelComboWidgetKind(combo);
    const dataList = getPanelComboDataList(field, reduxState);
    const label = t(`${mk}.filter.${field}`, {
      defaultValue: t(`semanticSearch.filterFields.${field}`, { defaultValue: field }),
    });
    const Checklist =
      kind === 'multi'
        ? CheckListOptionsCatalogStateMulti
        : kind === 'location'
          ? CheckListOptionsCatalogStateLocat
          : CheckListOptionsCatalogState;
    return (
      <Accordion.Item eventKey={`dyn-${index}`} key={field}>
        <Accordion.Header>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span className="tit-view viewContentTitIndicator">{label}</span>
            <BsInfoCircle style={{ marginLeft: '5px' }} data-tip data-for={`${field}_tip`} />
          </div>
        </Accordion.Header>
        <Accordion.Body>
          <Checklist
            dataList={dataList}
            title={label}
            keyCatalog={field}
            {...shared}
          />
        </Accordion.Body>
      </Accordion.Item>
    );
  };

  return (
    <div>
      <EndUserRemoveFilterOptionsL3
        {...shared}
        setModuleSelected={setModuleSelected}
        setCatalogCiiuLevel1Selected={setCatalogCiiuLevel1Selected}
      />

      <div style={{ fontWeight: '600', paddingTop: '1em', borderBottom: 'red 0.2em solid', fontSize: '1.4rem' }}>
        <span>{t(`${mk}.search.filters`)}</span>
      </div>

      <div className="accordionFilter">
        <Accordion defaultActiveKey="0" flush alwaysOpen>
          {combos.map(renderCombo)}
        </Accordion>

        {combos.map((combo) => (
          <ReactTooltip id={`${combo.field_name}_tip`} place="left" effect="solid" key={`tip-${combo.field_name}`}>
            {t(`${mk}.short.${combo.field_name}`, {
              defaultValue: t(`semanticSearch.filterFields.${combo.field_name}`, { defaultValue: combo.field_name }),
            })}
          </ReactTooltip>
        ))}
      </div>

      {moduleHasIndicators(mk) && (
        <>
          <div style={{ fontWeight: '600', paddingTop: '1em', borderBottom: 'red 0.2em solid', fontSize: '1.4rem' }}>
            <span>{t(`${mk}.search.indicators_title`)}</span>
          </div>
          <div className="accordionFilter">
            <Accordion defaultActiveKey="2" flush alwaysOpen>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span className="tit-view viewContentTitIndicator">{t(`${mk}.search.${INDICATORS_TITLE}`)}</span>
                    <BsInfoCircle style={{ marginLeft: '5px' }} data-tip data-for={`${INDICATORS_TITLE}_tip`} />
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  {PANEL_INDICATORS.map((ind) => (
                    <div className="percentItem" key={ind.name}>
                      <PercentajeReactInputRange
                        indicator_name={ind.name}
                        valueMin={catalog[ind.min]}
                        valueMax={catalog[ind.max]}
                        {...shared}
                      />
                    </div>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <ReactTooltip id={`${INDICATORS_TITLE}_tip`} place="left" effect="solid">
              {t(`${mk}.search.${INDICATORS_TITLE_INFO}`)}
            </ReactTooltip>
          </div>
        </>
      )}
    </div>
  );
};

export default L3FilterDynamic;
